import AutomationProgresser from './AutomationProgresser.component';

export default AutomationProgresser;